import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import styles from '../CategoryContainer.module.scss'

import { ErrorView } from '@percent/partner-dashboard/common/components/errorView/ErrorView'
import { CategoryTableProps, CategoryTableItemTypes } from './CategoryTable.types'
import { Copy, Icon, Table, TableBody, TableCell, TablePagination, TableProvider, TableRow } from '@percent/lemonade'

export function CategoryTable({
  data,
  isLoading,
  totalResults,
  errorMessage,
  nextPage,
  previousPage
}: CategoryTableProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  if (errorMessage) {
    return <ErrorView errorMessage={errorMessage} />
  }

  const rowCategoryClicked = (categoryId: string) => navigate(`/categories/${categoryId}`)

  const columns = [
    { id: t('table.header.name'), isSortable: false, props: { width: '38%' } },
    { id: t('table.header.id'), isSortable: false, props: { width: '50%' } },
    { id: '', isSortable: false, props: { width: '2%' } }
  ]

  return (
    <TableProvider
      columns={columns}
      totalResults={totalResults}
      isLoading={isLoading || !data}
      illustration="no-results"
      emptyTableTitle={t('typography.noCategoryTable')}
    >
      <Table>
        <TableBody>
          {data?.map(({ id, name }: CategoryTableItemTypes) => (
            <TableRow key={id}>
              <TableCell>{name}</TableCell>
              <TableCell>
                <Copy message={t('typography.copyId')} text={id}>
                  <span className={styles.spanId}>{id}</span>
                </Copy>
              </TableCell>
              <TableCell
                className={styles.rowCategoryArrow}
                dataTestId={`${name}-category-clicked`}
                onClick={() => rowCategoryClicked(id)}
              >
                <Icon name="chevron-right" size="s" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        totalResultsText={t('table.results', { count: totalResults || undefined })}
        previousPage={previousPage}
        nextPage={nextPage}
      />
    </TableProvider>
  )
}
